import { IconStarActive } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconStarFilled: FC<IconProps> = props => (
  <SvgIcon {...props} component={IconStarActive} />
)

export default IconStarFilled
